import {
    GivelifyButtonPublicPage as GivelifyButtonPublicPageInternal,
    FacebookGiving as FacebookGivingInternal,
    FundraisingToolsRoot as FundraisingToolsRootInternal,
    GivelifyButtonPage as GivelifyButtonPageInternal,
    InstagramGiving as InstagramGivingInternal,
    OnlineGiving as OnlineGivingInternal,
    SnapToGive as SnapToGiveInternal,
    SocialMediaGiving as SocialMediaGivingInternal,
    SocialMediaGivingItemsWrapper as SocialMediaGivingItemsWrapperInternal,
    TwitterGiving as TwitterGivingInternal,
    YouTubeGiving as YouTubeGivingInternal
} from '@givelify/fundraising-tools';

export const GivelifyButtonPublicPage = GivelifyButtonPublicPageInternal;
export const FacebookGiving = FacebookGivingInternal;
export const FundraisingToolsRoot = FundraisingToolsRootInternal;
export const GivelifyButtonPage = GivelifyButtonPageInternal;
export const InstagramGiving = InstagramGivingInternal
export const OnlineGiving = OnlineGivingInternal;
export const SnapToGive = SnapToGiveInternal;
export const SocialMediaGiving = SocialMediaGivingInternal;
export const SocialMediaGivingItemsWrapper = SocialMediaGivingItemsWrapperInternal;
export const TwitterGiving = TwitterGivingInternal;
export const YouTubeGiving=YouTubeGivingInternal;
